module.exports = __webpack_public_path__ + "static/media/works1.9e30b59b.png";